export default __webpack_public_path__ + "static/media/zodiacLogo.b02185f6.png";